<template>
  <CModal :show="true" :closeOnBackdrop="false" class="modal-app-update" content-class="modal-app-update__content">
    <template #header>
      <div class="modal-app-update__header">
        <div class="modal-app-update__icon-wrap">
          <svg class="modal-app-update__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" aria-hidden="true" style="color: #2563eb;">
            <path fill="currentColor" d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"/>
          </svg>
        </div>
        <h5 class="modal-app-update__title">{{ $t("global.modals.app_update.title") }}</h5>
      </div>
    </template>

    <div class="modal-app-update__body">
      <h4 class="modal-app-update__subtitle">
        {{ $t("global.modals.app_update.subtitle") }}
      </h4>
      <p class="modal-app-update__message">
        {{ $t("global.modals.app_update.message") }}
      </p>
      <CButton
        color="primary"
        class="modal-app-update__btn"
        @click="$emit('refresh')"
      >
        <svg class="modal-app-update__btn-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
        </svg>
        {{ $t("global.modals.app_update.refresh_now") }}
      </CButton>
    </div>
  </CModal>
</template>

<script>
export default {};
</script>

<style>
.modal-app-update footer.modal-footer {
  display: none;
}
</style>

<style scoped>
.modal-app-update :deep(.modal-content) {
  border: 0;
  border-radius: 16px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.12), 0 8px 16px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.modal-app-update :deep(.modal-header) {
  border-bottom: 0;
  padding: 0;
  flex-direction: column;
  align-items: stretch;
}

.modal-app-update__header {
  padding: 2rem 2rem 0;
  text-align: center;
}

.modal-app-update__icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin: 0 auto 1rem;
  border-radius: 50%;
  background-color: #dbeafe;
  background-image: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.2);
}

.modal-app-update__icon-wrap .modal-app-update__icon {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  display: block;
  animation: modal-app-update-spin 3s linear infinite;
}

.modal-app-update__title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--cui-body-color);
  letter-spacing: -0.02em;
}

.modal-app-update__body {
  padding: 1.25rem 2rem 2rem;
  text-align: center;
}

.modal-app-update__subtitle {
  margin: 0 0 0.75rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--cui-body-color);
  line-height: 1.4;
}

.modal-app-update__message {
  margin: 0 0 1.5rem;
  font-size: 0.9375rem;
  color: var(--cui-secondary-color);
  line-height: 1.5;
  max-width: 320px;
  margin-left: auto;
  margin-right: auto;
}

.modal-app-update__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.625rem 1.5rem;
  font-weight: 600;
  font-size: 0.9375rem;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.modal-app-update__btn-icon {
  width: 1.125rem;
  height: 1.125rem;
  margin-right: 0.5rem;
  flex-shrink: 0;
}

.modal-app-update__btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.35);
}

@keyframes modal-app-update-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
